import React from "react";
import LegalLayout, { LegalBlock } from "../components/LegalLayout";

const Impressum = () => {
  return (
    <LegalLayout title="Impressum" subtitle="Angaben gemäß § 5 TMG">
      <LegalBlock heading="Anbieter">
        <p className="text-[#17140f]">ROI DES ROIS GmbH</p>
        <p>Boelckestr. 62</p>
        <p>55252 Wiesbaden</p>
        <p>Deutschland</p>
      </LegalBlock>

      <LegalBlock heading="Vertreten durch">
        <p>Geschäftsführer: Kushtrim Rukiqi</p>
      </LegalBlock>

      <LegalBlock heading="Kontakt">
        <p>Telefon: +49 (0) 151 / 249 70003</p>
        <p>
          E-Mail:{" "}
          <a
            href="mailto:info@roidesrois.de"
            className="text-gold hover-underline"
          >
            info@roidesrois.de
          </a>
        </p>
        <p>
          Web:{" "}
          <a
            href="https://www.roidesrois.de"
            className="text-gold hover-underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.roidesrois.de
          </a>
        </p>
      </LegalBlock>

      <LegalBlock heading="Registereintrag">
        <p>Eingetragen im Handelsregister.</p>
        <p>Registergericht: Amtsgericht Wiesbaden</p>
        <p>Registernummer: HRB 36076</p>
        <p>EU ID: DEM1906.HRB36076</p>
      </LegalBlock>

      <LegalBlock heading="Umsatzsteuer-ID">
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        </p>
        <p>DE40 242 60617</p>
      </LegalBlock>

      <LegalBlock heading="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
        <p>Kushtrim Rukiqi</p>
        <p>Anschrift wie oben.</p>
      </LegalBlock>

      <LegalBlock heading="Hinweis auf EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            className="text-gold hover-underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </LegalBlock>

      <LegalBlock heading="Haftung für Inhalte und Links">
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für
          die Richtigkeit, Vollständigkeit und Aktualität können wir jedoch keine
          Gewähr übernehmen. Trotz sorgfältiger Kontrolle übernehmen wir keine
          Haftung für externe Links. Für den Inhalt verlinkter Seiten sind
          ausschließlich deren Betreiber verantwortlich.
        </p>
      </LegalBlock>
    </LegalLayout>
  );
};

export default Impressum;
